var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m507.27 223.17c13.062-33.758 11.711-69.707-3.7031-98.621-32.414-60.781-95.32-98.543-164.16-98.543-152.07 0-251.86 178.61-133.98 323.75 33.188 40.879 44.445 95.922 30.109 147.24-2.6562 9.4844-5.7578 19.238-9.2266 28.996-0.64844 1.8359-0.36719 3.875 0.75781 5.4688 1.1172 1.5938 2.9453 2.5391 4.8984 2.5391h176.8c1.6406 0 3.2031-0.67188 4.3359-1.8555s1.7344-2.7812 1.6562-4.418c-1.2344-26.977 5.2578-54.805 19.305-82.777h28.508c17.422 0 31.594-14.172 31.594-31.59v-24.16c3.3398-3.9219 34.617-8.3438 19.922-30.559 8.4375-7.3672 8.6641-17.109 2.0156-26.504 10.977-4.5234 23.078-3.7773 28.555-16.078 2.3281-5.2422 2.2891-11.23-0.10937-16.426-26.004-56.309-46.34-52.805-37.281-76.461zm-7.6094 104.64c-1.5234 6.5117 9.9844 10.723 9.0938 17.801-0.67187 5.3555-8.2227 5.3398-9.1641 10.695-0.30469 1.7812 0.20312 3.6016 1.3906 4.9648 5.3594 6.1523 4.9453 8.2539 4.9375 8.2734-0.17578 0.84766-5.4922 2.918-20.43 10.582-5.7344 2.8555-2.3438 8.6875-3.3203 33.23 0 10.801-8.7891 19.59-19.594 19.59h-32.172c-2.2344 0-4.2812 1.2422-5.3203 3.2188-15.062 28.816-22.602 57.66-22.469 85.832h-162.23c2.4609-7.332 4.7031-14.625 6.7109-21.773v-0.003906c15.375-55.059 3.2812-114.14-32.359-158.03-111.31-137.04-17.578-304.18 124.66-304.18 64.406 0 123.25 35.324 153.57 92.191 13.773 25.832 14.906 58.141 3.1016 88.66-12.125 31.617 12.738 32.07 37.586 85.805 7.3672 15.996-31.711 13.359-34 23.148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.73 264.11c-45.875-4.9883-80.172-32.246-83.391-66.281-0.16406-1.6797-1.0234-3.2109-2.3672-4.2266-1.3438-1.0195-3.0703-1.418-4.7188-1.1055-63.043 11.848-81.223 70.57-32.281 101.18 3.9609 18.449 15.852 33.656 34.539 44.113 0.92188 0.51172 1.9297 0.76172 2.9297 0.76172 1.5 0 2.9922-0.56641 4.1328-1.6523 1.9062-1.8125 2.4141-4.6562 1.2422-7.0117-3.5625-7.1875-5.0625-14.898-4.4844-22.988 38.148 5.1875 74.031-9.4023 88.867-33.695 1.0703-1.7539 1.1719-3.9336 0.26562-5.7773s-2.6953-3.0938-4.7344-3.3164zm-69.609 31.805c-6.125 0-12.281-0.59375-18.82-1.8203-3.1953-0.60938-6.3828 1.5234-7 4.7812-1.1875 6.3008-1.4141 12.453-0.67188 18.422-8.2812-7.9102-13.516-17.52-15.352-28.383-0.29688-1.7617-1.3594-3.2969-2.9062-4.1914-15.484-8.9648-24.367-21.918-24.367-35.531 0-19.391 17.945-36.719 44.359-43.539 6.7031 33.953 39.188 60.941 82.727 68.887-12.586 13.207-34.211 21.375-57.969 21.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.05 124c-52.406 0-95.039 30.719-95.039 68.48 0 37.758 42.633 68.477 95.039 68.477 6.1953 0 12.406-0.44141 18.539-1.3125 0.96875 10.234-0.79688 19.953-5.2734 28.965-1.1719 2.3555-0.66406 5.2031 1.2422 7.0156 1.1406 1.0898 2.6328 1.6523 4.1328 1.6523 1.0078 0 2.0156-0.25 2.9375-0.76953 21.992-12.344 35.93-30.289 40.461-52.027 21.008-12.996 33-31.82 33-52 0-37.762-42.633-68.48-95.039-68.48zm53.633 111.53c-1.5469 0.89453-2.6094 2.4297-2.9062 4.1875-2.3906 14.105-9.5156 26.465-20.852 36.402 1.3516-7.8906 1.2344-16.086-0.38281-24.523-0.29687-1.5664-1.2031-2.9453-2.5234-3.8398-1-0.67969-2.1719-1.0352-3.3672-1.0352-0.375 0-0.75781 0.035156-1.1328 0.10547-7.375 1.4141-14.938 2.1328-22.469 2.1328-45.789 0-83.039-25.336-83.039-56.477 0-31.145 37.25-56.48 83.039-56.48s83.039 25.336 83.039 56.48c0 16.535-10.719 32.223-29.406 43.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.02 178.61c-7.8359 0-14.223 6.3867-14.223 14.285 0 7.8945 6.3867 14.285 14.223 14.285 7.8945 0 14.285-6.3867 14.285-14.285 0-7.8984-6.3906-14.285-14.285-14.285z"
  }), " -->\n  ", /*#__PURE__*/React.createElement("path", {
    d: "m394.02 178.61c-7.8359 0-14.223 6.3867-14.223 14.285 0 7.8945 6.3867 14.285 14.223 14.285 7.8945 0 14.285-6.3867 14.285-14.285 0-7.8984-6.3906-14.285-14.285-14.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.02 178.61c-7.8359 0-14.223 6.3867-14.223 14.285 0 7.8945 6.3867 14.285 14.223 14.285 7.8945 0 14.285-6.3867 14.285-14.285 0-7.8984-6.3906-14.285-14.285-14.285z"
  }), " -->\n  ", /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 680,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 99.355469,
    y: 680,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 119.082031,
    y: 680,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 146.210938,
    y: 680,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 173.203125,
    y: 680,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192.324219,
    y: 680,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 219.453125,
    y: 680,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.011719,
    y: 680,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.644531,
    y: 680,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.644531,
    y: 680,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.601562,
    y: 680,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 388.730469,
    y: 680,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.441406,
    y: 680,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 431.5625,
    y: 680,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 459.042969,
    y: 680,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 478.769531,
    y: 680,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.503906,
    y: 680,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.820312,
    y: 680,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.300781,
    y: 680,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.011719,
    y: 680,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.488281,
    y: 680,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 720,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 87.402344,
    y: 720,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 107.128906,
    y: 720,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 134.609375,
    y: 720,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 190.214844,
    y: 720,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 209.335938,
    y: 720,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 237.8125,
    y: 720,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.867188,
    y: 720,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.34375,
    y: 720,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.824219,
    y: 720,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.300781,
    y: 720,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 410.703125,
    y: 720,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.019531,
    y: 720,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 459.746094,
    y: 720,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.226562,
    y: 720,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 500.9375,
    y: 720,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.066406,
    y: 720,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.777344,
    y: 720,
    xlinkHref: "#a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscourse);
export default __webpack_public_path__ + "static/media/discourse.88c928e633d35707ae549c96b38a00e4.svg";
export { ForwardRef as ReactComponent };